<template>
  <div class="product-form-overrider" :class="{ 'product-form-overrider--active': !value }">
    <slot />
    <div v-if="!value" class="product-form-overrider__content">
      <div>{{ $t('productOverrideMessage', { value: label }) }}</div>
      <ButtonComponent :label="buttonLabel" :icon="['fal', 'pen']" @click="$emit('override')" />
    </div>
    <a v-if="active && value" href="#" @click.prevent="$emit('reset')" class="product-form-overrider__reset">
      <FontAwesomeIcon :icon="['fal', 'undo']" size="sm" />
      {{ $t('productOverrideReset', { value: label }) }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    active: Boolean,
    label: String,
  },
  computed: {
    buttonLabel() {
      return `${this.$t('edit')} "${this.label}"`
    },
  },
}
</script>

<style lang="scss">
.product-form-overrider {
  position: relative;

  &--active {
    &:before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(white, 0.6);
      z-index: 1;
      transition: opacity 150ms ease;
    }
  }

  &__reset {
    display: block;
    text-align: center;
    margin-top: 0.5rem;
    text-decoration: none;
  }

  &__content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 1rem;
    width: 100%;
    max-width: 350px;
    background-color: white;
    border-radius: var(--border-radius);
    border: 1px solid var(--border-color);
    box-shadow: 0 10px 15px -7px rgba(0, 0, 0, 0.1);
    padding: 1rem;
    text-align: center;
    z-index: 2;

    button {
      margin-top: 1rem;
    }
  }
}
</style>
